module.exports = __webpack_public_path__ + "img/cart.513472ef.png";